// Utility function to detect if the user is on a mobile device
// eslint-disable-next-line import/prefer-default-export
export const isMobile = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
};
